// extracted by mini-css-extract-plugin
export default {"zoomControls":"X--z","zoomControlButton":"Y--z","zoomBanner":"Z--z","bannerButton":"_--z","imageButton":"a_-z","zoom":"b_-z","zoomContent":"c_-z"};